import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'listPrint'
})
export class ListPrintPipe implements PipeTransform {

  transform = (objects: any = []) => {
    return Object.values(objects);
  }

}
